import { Drawer, List, ListItem } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import React from "react";
import { Link, useLocation } from "react-router-dom";

interface StyleProps {
  ref: HTMLElement | null;
  width: number;
}

const useStyles = makeStyles<unknown, StyleProps>(() => ({
  drawerPaper: (props) => ({
    width: props.width,
    top: "75px",
    left:
      (props.ref?.offsetLeft ?? 0) +
      (props.ref?.clientWidth ?? 0) / 2 -
      props.width / 2,
    borderRadius: "4px",
  }),
  drawerPaperArrow: (props) => ({
    width: 0,
    height: 0,
    borderLeft: "20px solid transparent",
    borderRight: "20px solid transparent",
    borderBottom: "20px solid white",
    position: "fixed",
    left: (props.ref?.offsetLeft ?? 0) + (props.ref?.clientWidth ?? 0) / 2 - 20,
    top: "55px",
  }),
  listItem: {
    padding: 0,
  },
  linkItem: {
    fontSize: "1rem",
    textDecoration: "none",
    color: "inherit",
    width: "100%",
    paddingTop: 10,
    paddingLeft: 15,
    paddingRight: 15,
    paddingBottom: 7,
  },
}));

interface Props {
  open: boolean;
  onClose: () => void;
  listItems: Array<{ label: string; path: string }>;
  width: number;
  topbarItemRef: React.MutableRefObject<HTMLElement | null>;
}

const TopbarDrawer: React.FC<Props> = ({
  open,
  onClose,
  listItems,
  width,
  topbarItemRef,
}: Props) => {
  const ref = topbarItemRef.current;
  const classes = useStyles({ ref, width });
  const location = useLocation();
  const theme = useTheme();
  const getListItemColor = (path: string) => {
    if (location.pathname === path) {
      return { color: theme.palette.secondary.light };
    }
    return {};
  };
  return (
    <>
      {ref && (
        <Drawer
          anchor="top"
          open={open}
          transitionDuration={0}
          onClose={onClose}
          classes={{
            paper: classes && classes.drawerPaper,
          }}
        >
          <div className={classes && classes.drawerPaperArrow} />
          <List>
            {listItems.map((listItem) => (
              <ListItem
                button
                onClick={onClose}
                className={classes.listItem}
                key={listItem.path}
                style={getListItemColor(listItem.path)}
              >
                <Link className={classes.linkItem} to={listItem.path}>
                  {listItem.label}
                </Link>
              </ListItem>
            ))}
          </List>
        </Drawer>
      )}
    </>
  );
};

export default TopbarDrawer;



// WEBPACK FOOTER //
// ./src/components/TopbarDrawer.tsx